import { render, staticRenderFns } from "./AggFacturaPorServicioComponent.vue?vue&type=template&id=0163ad81&"
import script from "./AggFacturaPorServicioComponent.vue?vue&type=script&lang=js&"
export * from "./AggFacturaPorServicioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports